import React from 'react';

import styles from './Services.module.scss';
import { CAR_SERVICES } from '../utils/Constants';
import IconTooltip from './IconTooltip';

export default function Services({ data }) {
	return (
		<div className={styles.root}>
			{CAR_SERVICES.map((service, index) => {
				if (
					data[service.name] &&
					(data[service.name] === 'SI' ||
						service.name === 'RiparazioniVeicoliParticolari')
				) {
					return <IconTooltip service={service} key={index} />;
				}
			})}
		</div>
	);
}
